import Availability from "./availability";

export default Availability;
